
<h2>{{message}}</h2>

<div *ngIf="message2">
  <h3>{{message2}}</h3>
</div>

